import { InjectionToken } from '@angular/core';
import { AuthConfig } from './auth.interface';

export const AUTH_CONFIG = new InjectionToken<AuthConfig>('AuthConfig');



// WEBPACK FOOTER //
// ./src/app/@shared/auth/auth.config.ts